"use strict";
function PartialFetcher(store, bulkFetcher, storeUpdater) {
  return {
    fetchItemIfNeeded: function(id) {
      return this.fetchItemsIfNeeded([id]).then(function(items) {
        return _.first(items);
      });
    },
    fetchItemsIfNeeded: function(ids, validator) {
      var loader = $.Deferred();
      var toFetch = [];
      var result = [];
      _.each(ids, function(id) {
        var existing = store.find(id);
        if (!existing || validator && !validator(existing)) {
          toFetch.push(id);
        } else {
          result.push(existing);
        }
      }.bind(this));
      if (toFetch.length > 0) {
        bulkFetcher(toFetch).then(function(items) {
          if (storeUpdater) {
            storeUpdater(items);
          } else {
            store.addOrUpdateAll(items);
          }
          result = _.map(ids, function(id) {
            return store.find(id);
          });
          loader.resolve(result);
        });
      } else {
        loader.resolve(result);
      }
      return loader.promise();
    }
  };
}
export default PartialFetcher;
